module.exports = {
  validate(rule) {
    // Either one or the other must be true, not both, hence the XOR.
    // !! because there is no logical XOR, only bitwise
    return !!(this.hasValidResellerFlag(rule) ^ this.hasValidPlidList(rule));
  },

  hasValidResellerFlag(rule) {
    return typeof(rule.isReseller) === 'boolean';
  },

  hasValidPlidList(rule) {
    return Array.isArray(rule.plids);
  },

  test({ rule, params }) {
    const plid = params.plid || 1;

    if (this.hasValidResellerFlag(rule)) {
      return this.matchPlid(plid, 1) !== rule.isReseller;
    }

    if (this.hasValidPlidList(rule)) {
      return rule.plids.some(item => this.matchPlid(item, plid));
    }

    return false;
  },

  matchPlid(a, b) {
    // Intentional `==` because a common mistake is to use a string rather than
    // a number for plid
    return a == b;
  }
};
